import { Box, Grid2, IconButton, Stack, Typography } from '@mui/material';
import * as React from 'react';
import { ProjectBudgetDTO } from '../Api/ApiServer';
import { Info } from '@mui/icons-material';

export interface IProjectBudgetListProps {
    // distinctParts: string[];
    budgetItems: ProjectBudgetDTO[];
    onItemSelected?: (item: ProjectBudgetDTO) => void;
}

export default function ProjectBudgetList(props: IProjectBudgetListProps) {
    const { budgetItems, onItemSelected } = props;
    const [distinctParts, setDistinctParts] = React.useState<string[]>([]);
    React.useEffect(() => {
        const distinctPartValues = Array.from(
            new Set(budgetItems.map(item => item.orderNumberSecond!))
        );
        setDistinctParts(distinctPartValues);
    }, [budgetItems]);
    return (
        <Grid2 container spacing={2} borderRadius={1}>
            {distinctParts.map((part) => {
                const items = budgetItems.filter(item => item.orderNumberSecond === part);
                const partName = items?.[0]?.partName;
                const object = items?.[0]?.orderNumber;
                const objectName = items?.[0]?.objectName;
                console.log(partName);
                // return <Grid2 boxShadow={4} p={2} borderRadius={4} size={{ xs: 12 }}>
                return <Grid2 p={1} borderRadius={1} spacing={1} boxShadow={3} container size={{ xs: 12 }}>
                    <Grid2 my={2} textAlign={'left'} size={{ xs: 12 }}>
                        {(part || partName) ? <Typography variant='h6'>{part} - {partName}</Typography> : <Typography variant='h6'>{object} - {objectName}</Typography>}
                        {/* <Typography variant='body1'>{object} - {objectName}</Typography> */}
                    </Grid2>
                    {
                        items?.map(item => <Grid2 container borderRadius={1} width={'100%'} minWidth={'100%'} bgcolor={item.amount ? 'primary.light' : 'error.light'} spacing={3} textAlign={'start'} p={1} >

                            <Grid2 size={{ xs: 12 }}>
                                <Box display='flex' justifyContent='space-between'>
                                    <Stack direction={'row'} spacing={1}>
                                        <Typography variant='body2'>{item.itemCode}</Typography>
                                        <Typography variant='body2'>{item.itemName}</Typography>
                                    </Stack>
                                    <IconButton onClick={() => { onItemSelected?.(item) }}> <Info fontSize='small' /></IconButton>
                                </Box>
                            </Grid2>
                            {item.amount !== 0 && <Grid2 textAlign={'start'} size={{ xs: 3 }}>
                                <Typography variant='body2'>{item.unitPrice?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' Kč'}</Typography>
                            </Grid2>}
                            {item.amount !== 0 && <Grid2 textAlign={'end'} size={{ xs: 4 }}>
                                <Typography variant='body2'>{item.amount?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</Typography>
                            </Grid2>}
                            {item.amount !== 0 && <Grid2 textAlign={'end'} size={{ xs: 5 }}>
                                <Typography variant='body2'>{(item.amount! * item.unitPrice!).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' Kč'}</Typography>
                            </Grid2>}
                            {!item.amount && <Grid2 size={{ xs: 12 }}>
                                <Typography color='error' variant='body2'>NENÍ SOUČÁSTÍ NABÍDKY</Typography>
                            </Grid2>}

                        </Grid2>)
                    }
                </Grid2>
            })}
        </Grid2>
    );
}
